import Highcharts = require("highcharts");
import { LineSerie } from "./line.serie";
import { Component, OnInit, Inject } from "@angular/core";
import { DashboardDataService } from "../core/dashboarddataservice";

@Component({
    selector: "crew-person-activities-graph",
    template: require('./person-activities-graph.component.html')
})
export class PersonActivitiesGraphComponent implements OnInit {

    constructor(
        @Inject("$log") private $log: ng.ILogService,
        private dashboardDataService: DashboardDataService) {
    }

    ngOnInit() {
        this.dashboardDataService
            .searchDayActivities({ ActivityTypeIds: null, JobTitleIds: null, WorkplaceIds: null, PersonIds: null, Day: null })
            .then(res => {
                var data: LineSerie[] = [];

                for (var i = 0; i < res.length; i++) {

                    var dataPoint = res[i];
                    data.push({ name: dataPoint.Activity, y: dataPoint.Count });
                }

                this.refreshGraph(data);
            })
            .catch(err => this.$log.error(err));
    }

    private refreshGraph(dataSource: LineSerie[]) {
        // Build the chart
        Highcharts.chart('person-activities-graph', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: 'Person Activities'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                name: 'Person Activities',
                colorByPoint: true,
                data: dataSource
            }]
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/person-activities-graph.component.ts